module.exports = __webpack_public_path__ + "static/gehwol-c71583f9740d7308a07e5c8304da9b7b.jpg";